import type { DSNCPromoted, DSResource } from 'shared-definitions/types'
import type { ApiComponent, ApiComponentPromotedProps } from 'data-source/types.wp'

interface PromotedOpts<T extends DSResource, A extends ApiComponent> {
  componentItemMapper: (input: A) => T | T[]
}

export function ncPromoted<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentPromotedProps<A>,
  opts: PromotedOpts<T, A>
): DSNCPromoted<T> {
  return {
    resource: 'nc-promoted',
    blocks: input.content?.flatMap(opts.componentItemMapper) || [],
  }
}
